export default "__VITE_PUBLIC_ASSET__e453cb6d__"